/* eslint-disable no-dupe-keys */
export default {
  product_order: {
    name: '商品订单',
    // 属性
    prop: {
      trade_number: '订单号',
      product: '商品名称',
      buys_count: '购买数量',
      user: '用户',
      user_id: '用户',
      points: '使用积分',
      market_price: '单价',
      amount: '支付现金',
      payable_amount: '总价',
      status: '支付状态',
      logistics_status: '物流状态',
      aggregated_status: '状态',
      tags: '商品分类',
      created_at: '购买时间',
      updated_at: '更新时间',
      product_name: '商品名称',
      logistics_tracking_number: '快递单号',
      logistics_company: '快递公司',
      logistics_customer_name: '手机尾号',
      paid_at: '支付时间',
      admin: '代理商',
      admin_id: '代理商',
      sale_agent_reward: '代理返现',
      shipping_method: '送货方式',
      logistics_statuses: '物流状态',
      description: '备注',
      plate_number: '车牌',
      vin: 'VIN'
    },
    // 列表页字段（search display也重用）
    aggregated_statuses: {
      unpaid: '未支付',
      cancelled: '已取消',
      processing: '待处理',
      shipped: '已发货',
      in_transit: '在途中',
      out_for_delivery: '派送中',
      unclaimed: '待核销',
      complete: '已完成',
      closed: '交易关闭'
    },
    logistics_statuses: {
      processing: '待处理',
      shipped: '已发货',
      in_transit: '在途中',
      out_for_delivery: '派送中',
      unclaimed: '待核销',
      complete: '已完成'
    },
    titles: {
      logistics: '物流信息'
    },
    labels: {
      logistics: '物流信息',
      qrcode: '核销二维码',
      verifier: '核销员',
      verified_time: '核销时间',
      pickup_location: '提货点',
      total_count: '数量',
      sale_agent_reward: '代理返现金',
      agent_orders_count: '代理订单数'
    },
    list_tabs: {
      all: '全部',
      unpaid: '未支付',
      processing: '待处理',
      unclaimed: '待核销',
      paid: '派送中',
      closed: '交易关闭',
      complete: '已完成'
    },
    // Enum的属性
    statuses: {
      unpaid: '未支付',
      paid: '已支付',
      cancelled: '已取消',
      closed: '交易关闭'
    },
    btn: {
      mark_selected: '标记为已完成'
    },
    toast: {
      not_selected: '没有选中记录'
    },
    shipping_methods: {
      auto_delivery: '自动发货',
      express_delivery: '快递',
      pickup: '自提'
    },
    // Boolean的属性
    // 占位提示
    placeholder: {
      search_keyword: '订单号/商品名',
      input_customer_name: '顺丰速运需填 寄件人/收件人 手机号后四位'
    },
    detail: {
      base_info: '商品信息',
      order_info: '订单信息',
      logistics_info: '物流信息',
      logistics_record: {
        tracking_number: '快递单号',
        company: '快递公司',
        shipping_method: '发货方式',
        created_at: '发货时间',
        nick_name: '收件人',
        mobile: '联系方式',
        address: '收货地址',
        pickup_location: '提货地址'
      }
    },
    btns: {
      redeem: '核销'
    },
    tips: {
      qrcode_indication: '打开移动运营端，点击：我的 > 积分商城 > 商品核销，扫码核销。',
      confirm_redeem: '确认要核销该商品订单（订单号 {0}）吗？',
      confirm_multi_mark_completed: '确认要将指定的商品订单标记为已完成吗？',
      redeem_succeed: '核销成功'
    }
  }
}
